/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Sunday, April 17th 2022, 9:16:11 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { ContextTagSelector, ContextTagSelectorProps } from "./ContextTagSelector";
import { useToggleState } from "ui-widgets/dialogs/useToggleState";

interface ContextTagSelectorButtonWrapperProps
  extends Pick<ContextTagSelectorProps, "onCopyContextTag" | "copiedMessage" | "contextTagsAPIFilters"> {
  children: (args: { openContextTagsFn: () => void }) => React.ReactNode;
}

export const ContextTagSelectorButtonWrapper = ({
  children,
  onCopyContextTag,
  copiedMessage,
  contextTagsAPIFilters,
}: ContextTagSelectorButtonWrapperProps) => {
  const {
    open: contexTagsOpenState,
    handleClose: closeContextTagsFn,
    handleOpen: openContextTagsFn,
  } = useToggleState();

  return (
    <>
      {children({ openContextTagsFn })}
      <ContextTagSelector
        onCopyContextTag={onCopyContextTag}
        copiedMessage={copiedMessage}
        open={contexTagsOpenState}
        onClose={closeContextTagsFn}
        contextTagsAPIFilters={contextTagsAPIFilters}
      />
    </>
  );
};
